import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=c2defa3a&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryTab.vue?vue&type=style&index=0&id=c2defa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2defa3a",
  null
  
)

export default component.exports